import { render, staticRenderFns } from "./SalesOrderViewDeliveries.vue?vue&type=template&id=54543fb3&scoped=true&"
import script from "./SalesOrderViewDeliveries.vue?vue&type=script&lang=js&"
export * from "./SalesOrderViewDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderViewDeliveries.vue?vue&type=style&index=0&id=54543fb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54543fb3",
  null
  
)

export default component.exports